import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import SocialShareButton from './SocialShareButton';
import s from './SocialShareButtons.scss';
var SocialShareButtons = /** @class */ (function (_super) {
    __extends(SocialShareButtons, _super);
    function SocialShareButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SocialShareButtons.prototype.render = function () {
        var _a = this.props, buttons = _a.buttons, url = _a.url, title = _a.title, hashtags = _a.hashtags, via = _a.via, media = _a.media, className = _a.className, buttonClassname = _a.buttonClassname, buttonProps = __rest(_a, ["buttons", "url", "title", "hashtags", "via", "media", "className", "buttonClassname"]);
        return (React.createElement("div", { className: classnames(s['social-share-buttons'], className) }, buttons.map(function (buttonType) { return (React.createElement(SocialShareButton, __assign({ key: buttonType, type: buttonType, className: buttonClassname, shareInfo: { url: url, title: title, hashtags: hashtags, via: via, media: media } }, buttonProps))); })));
    };
    return SocialShareButtons;
}(React.Component));
export default SocialShareButtons;
//# sourceMappingURL=SocialShareButtons.js.map